import Vue from 'vue'
import Vuex from 'vuex'
import _axios from '@/ws/domain.js';
import urls from '@/ws/api.js';
import commonMethods from '@/common/commonMethods.js';

Vue.use(Vuex);

const state = {
    isMobile: false, // 是否为移动端判断
    userDetail: {}, // 用户数据
    defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png', // 默认头像
    // 上传时头部信息
    uploadHeader: {
        Authorization: window.localStorage.getItem('token') ? 'Bearer' + window.localStorage.getItem('token') : 'Bearer'
    },
    columnList: [], // 栏目列表参数
    pageModuleList: [], // 页面模块参数
    goodsCateList: [], // 商品分类数据
    goodsDetailNavList: [], // 商品详情路径导航参数
}
const mutations = {
    /**
     * @function setEquipmentInfo 设置登录端信息
     * @param {*} state 
     * @param {*} res 
     */
    setEquipmentInfo(state, res) {
        state.isMobile = res.isMobile;
        window.sessionStorage.setItem("setEquipmentInfo", JSON.stringify(res));
    },
    /**
     * @function setColumnList 设置栏目参数
     * @param {*} state 
     * @param {*} res 
     */
    setColumnList(state, res) {
        state.columnList = res;
    },
    /**
     * @function setPageModuleList 设置页面模块参数
     * @param {*} state 
     * @param {*} res 
     */
    setPageModuleList(state, res) {
        state.pageModuleList = res;
    },
    /**
     * @function setUserDetail 设置用户数据
     * @param {*} state 
     * @param {*} res 
     */
    setUserDetail(state, res) {
        state.userDetail = res;
    },
    /**
     * @function setGoodsCateNavList 设置商品分类数据
     * @param {*} state 
     * @param {*} res 
     */
    setGoodsCateList(state, res) {
        state.goodsCateList = res;
    },
    /**
     * @function setGoodsDetailNavList 设置商品详情路径导航参数
     * @param {*} state 
     * @param {*} res 
     */
    setGoodsDetailNavList(state, res) {
        state.goodsDetailNavList = res;
        window.sessionStorage.setItem('goodsDetailNavList', JSON.stringify(res));
    }
}
const actions = {}
const pcModule = {
    state, mutations
}
const appModule = {
    state, mutations
}
export const store = new Vuex.Store({
    state,
    mutations,
    actions,
    modules: {
        pc: pcModule,
        app: appModule
    }
});


// WEBPACK FOOTER //
// ./src/vuex/store.js